

<template>
  <div class="dialog-video" v-if="show">
    <div class="close" @click="close"
         @mouseenter="svgColor = '#1B1B1B'"
         @mouseleave="svgColor = '#434343'"
    >
      <svg t="1750075915367" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5949" width="256" height="256"><path :fill="svgColor" d="M512 909.061224c-218.906122 0-397.061224-178.155102-397.061224-397.061224s178.155102-397.061224 397.061224-397.061224 397.061224 178.155102 397.061224 397.061224-178.155102 397.061224-397.061224 397.061224z"  p-id="5950" data-spm-anchor-id="a313x.search_index.0.i4.10e63a81Ux25rX" class="selected"></path><path d="M363.102041 680.75102c-5.22449 0-9.926531-2.089796-14.106123-5.746938-7.836735-7.836735-7.836735-20.37551 0-28.212245l297.795919-297.795919c7.836735-7.836735 20.37551-7.836735 28.212245 0 7.836735 7.836735 7.836735 20.37551 0 28.212245l-297.795919 297.795919c-4.179592 3.657143-8.881633 5.746939-14.106122 5.746938z" fill="#ffffff" p-id="5951" data-spm-anchor-id="a313x.search_index.0.i6.10e63a81Ux25rX" class=""></path><path d="M660.897959 680.75102c-5.22449 0-9.926531-2.089796-14.106122-5.746938l-297.795919-297.795919c-7.836735-7.836735-7.836735-20.37551 0-28.212245 7.836735-7.836735 20.37551-7.836735 28.212245 0l297.795919 297.795919c7.836735 7.836735 7.836735 20.37551 0 28.212245-4.179592 3.657143-8.881633 5.746939-14.106123 5.746938z" fill="#ffffff" p-id="5952" data-spm-anchor-id="a313x.search_index.0.i5.10e63a81Ux25rX" class=""></path></svg>
    </div>
    <div class="dialog-video-container">
      <myVideo ref="myVideoRef" :src="src" @downloadFile="downloadFile"></myVideo>
    </div>
  </div>
</template>

<script>

import myVideo from '../../../common/myvideo/img/myVideo.vue'

export default {
  name: 'dialog-video',
  components: {
    myVideo
  },
  data(){
    return {
      show: false,
      src: '',
      svgColor: '#434343',
      title: ''
    }
  },
  mounted() {
  },
  methods: {
    open(title, url){
      this.show = true
      this.title = title
      this.$nextTick(() => {
        this.$refs.myVideoRef.playerOptions['sources'][0]['src'] = url;
        this.$refs.myVideoRef.onPlayerPlay()
      })
    },
    close(){
      this.show = false
    },
    play(){

    },
    downloadFile(url){
      this.$emit('downloadFile', this.title, url)
    },

  }
}
</script>

<style scoped>
.dialog-video {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left:0;
  top: 0;
  background-color: rgba(0,0,0, .95);
  z-index: 9999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-video .dialog-video-container {
  position: relative;
}
.dialog-video .close {
  width: 64px;
  height: 64px;
  position: absolute;
  right: 40px;
  top: 40px;
  cursor: pointer;
}
.dialog-video .close .icon {
  width: 64px;
  height: 64px;
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
}
</style>
